import axios, { AxiosInstance } from 'axios';

export interface TimelineEvent {
  utc: string;
  sgt: string;
  title: string;
  detail: string | null;
  employee: string;
  device: string;
  action: string;
}

export interface TimelineResponse {
  invoice_uid: string;
  table: string;
  server: string;
  ref_id: string;
  status: string;
  watermark: string;
  events: TimelineEvent[];
}

class TimelineService {
  private client: AxiosInstance;

  constructor() {
    this.client = axios.create({
      baseURL: import.meta.env.VITE_INVOICE_ACTIVITY_API_URL,
      timeout: 15000,
    });
  }

  async getTimeline(invoiceUid: string): Promise<TimelineResponse> {
    const { data } = await this.client.get(`/invoices/${invoiceUid}/timeline`);
    return data;
  }
}

export const timelineService = new TimelineService();
